import React from 'react';
import GlobalContext from '../../contexts/GlobalContext';
import styled from 'styled-components';

import Notification from './Notification';

// TODO: None of this context is typed, this needs to be addressed.
const Notifications = () => {
	const { notifications, updateNotifications } = React.useContext(GlobalContext);

	const handleRemove = React.useCallback(
		(notification: ToastNotification) => {
			updateNotifications((oldNotifications) => {
				return oldNotifications.filter((notif) => notif !== notification);
			});
		},
		[updateNotifications]
	);

	if (notifications.length === 0) {
		return null;
	}

	return (
		<NotificationsContainer className="_fixed _top-0 _right-0 _w-full _mt-10 _text-gray-700 sm:_mr-5 sm:_w-1/2 md:_w-1/4">
			{notifications.map((notif) => (
				<Notification notification={notif} key={notif.id} onRemove={handleRemove} />
			))}
		</NotificationsContainer>
	);
};

export default Notifications;

const NotificationsContainer = styled.div`
	z-index: 550;
`;
